import React, { Component } from "react";

export class Constants extends Component {
    public static ServerDateFormat: any = "YYYY-MM-DD";
    public static DateFormat: any = "MM/DD/YYYY";
    public static DateTimeFormat: any = "MM/DD/YYYY HH:mm";
    public static DateTimeFormat12Hour: any = "MM/DD/YYYY hh:mm a";
    public static TimeFormat: any = "HH:mm:ss";
    public static TimeFormatNoSeconds: any = "HH:mm";
    public static UtcToLocal: any = "MM/DD/YYYY HH:mm:ss";

    public static Currency: any = "";
}